// Generated from Swagger on 2025-08-27T14:46:24.207Z

export enum InternalUserListEmployeeRole {
  ADMIN = "ADMIN",
}

export enum InternalInvitationType {
  INTERNAL_INVITATION = "internal-invitation",
  CUSTOMER_INVITATION = "customer-invitation",
}

export enum InternalUserUserType {
  INTERNAL_USER = "internal-user",
  CUSTOMER_USER = "customer-user",
}

export enum InternalUserEmployeeRole {
  ADMIN = "ADMIN",
}

export enum OrganizationListBanReason {
  NONE = "NONE",
  PAYMENT_OVERDUE = "PAYMENT_OVERDUE",
  INACTIVE_SUBSCRIPTION = "INACTIVE_SUBSCRIPTION",
  DEACTIVATED_BY_ADMIN = "DEACTIVATED_BY_ADMIN",
}

export enum OrganizationDetailsBanReason {
  NONE = "NONE",
  PAYMENT_OVERDUE = "PAYMENT_OVERDUE",
  INACTIVE_SUBSCRIPTION = "INACTIVE_SUBSCRIPTION",
  DEACTIVATED_BY_ADMIN = "DEACTIVATED_BY_ADMIN",
}

export enum CustomerUserListResponseDtoWithoutArchiveableCustomerRole {
  ADMIN = "ADMIN",
  USER = "USER",
}

export enum OrganizationBanReason {
  NONE = "NONE",
  PAYMENT_OVERDUE = "PAYMENT_OVERDUE",
  INACTIVE_SUBSCRIPTION = "INACTIVE_SUBSCRIPTION",
  DEACTIVATED_BY_ADMIN = "DEACTIVATED_BY_ADMIN",
}

export enum CustomerUserUserType {
  INTERNAL_USER = "internal-user",
  CUSTOMER_USER = "customer-user",
}

export enum CustomerUserCustomerRole {
  ADMIN = "ADMIN",
  USER = "USER",
}

export enum UpdateBanReasonBanReason {
  NONE = "NONE",
  PAYMENT_OVERDUE = "PAYMENT_OVERDUE",
  INACTIVE_SUBSCRIPTION = "INACTIVE_SUBSCRIPTION",
  DEACTIVATED_BY_ADMIN = "DEACTIVATED_BY_ADMIN",
}

export enum InternalPlanKey {
  BASIC = 'basic',
  PRO = 'pro',
  CUSTOM = 'custom',
}

export enum BillingStatus {
  TRIALING = 'trialing',
  ACTIVE = 'active',
  GRACE_PERIOD = 'grace_period',
  PAST_DUE = 'past_due',
  CANCELED = 'canceled',
  INACTIVE = 'inactive',
}

export enum BillingSource {
  STRIPE = 'stripe',
  LEGACY_MIGRATION = 'legacy_migration',
  SPECIAL_DEAL = 'special_deal',
  MANUAL = 'manual',
}

export interface BillingContract {
  _id: string;
  organizationId: string;
  planKey: InternalPlanKey;
  status: BillingStatus;
  source: BillingSource;
  stripeCustomerId?: string;
  stripeSubscriptionId?: string;
  stripePriceId?: string;
  currentPeriodEnd?: string;
  cancelAt?: string;
  metadata?: Record<string, any>;
  isPlanOverridden?: boolean;
  planOverrideReason?: string;
  createdAt: string;
  updatedAt: string;
  stripeCustomerPhone?: string;
}

export interface UpdateBillingContractRequestDto {
  planKey?: InternalPlanKey;
  status?: BillingStatus;
  source?: BillingSource;
  isPlanOverridden?: boolean;
  planOverrideReason?: string;
  stripeCustomerId?: string;
  stripeSubscriptionId?: string;
  stripePriceId?: string;
}

export interface InternalUserListPaginatedResponseDtoWithInvitationCount {
  invitationCount: number;
  users: InternalUserListPaginatedResponseDto;
}

export interface InternalUserListPaginatedResponseDto {
  limit: number;
  offset: number;
  page: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
  count: number;
  pageCount: number;
  docs: InternalUserListResponseDto[];
}

export interface ErrorDto {
  message: string;
  error: string;
  statusCode: number;
}

export interface InternalUserListResponseDto {
  _id: string;
  firstName: string;
  lastName: string;
  mail: string;
  isArchive: boolean;
  lastLogin: string;
  ownUser?: boolean;
  isArchiveable: boolean;
  employeeRole: InternalUserListEmployeeRole;
}

export interface InternalInvitationListPaginatedResponseDto {
  limit: number;
  offset: number;
  page: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
  count: number;
  pageCount: number;
  docs: InternalInvitationListResponseDto[];
}

export interface InternalInvitationListResponseDto {
  _id: string;
  firstName: string;
  lastName: string;
  mail: string;
  expiresAt?: string;
  createdAt: string;
}

export interface CreateInternalInvitationRequestDto {
  firstName: string;
  lastName: string;
  mail: string;
}

export interface InternalInvitationResponseDto {
  _id: string;
  firstName: string;
  lastName: string;
  mail: string;
  type: InternalInvitationType;
  expiresAt?: string;
  createdAt: string;
}

export interface InternalUserResponseDto {
  _id: string;
  firstName: string;
  lastName: string;
  mail: string;
  email_verified: boolean;
  email_verification_sent: boolean;
  userType: InternalUserUserType;
  isArchive: boolean;
  lastLogin: string;
  createdAt: string;
  updatedAt: string;
  employeeRole: InternalUserEmployeeRole;
}

export interface UpdateUserRequestDto {
  firstName?: string;
  lastName?: string;
  mail?: string;
}



export interface OrganizationListPaginatedResponseDtoWithCountsAndEntities {
  organizations: OrganizationListPaginatedResponseDto;
}

export interface OrganizationListPaginatedResponseDto {
  limit: number;
  offset: number;
  page: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
  count: number;
  pageCount: number;
  docs: OrganizationListResponseDto[];
}

export interface OrganizationListResponseDto {
  _id: string;
  name: string;
  banReason: OrganizationListBanReason;
  lastLogin: string;
  isOpenable?: boolean;
  subscriptionPlan?: string | null;
  subscriptionStatus?: string | null;
  createdAt: string;
  organizationAdmin?: { firstName?: string; lastName?: string; mail?: string };
}

export interface OrganizationDetailsResponseDto {
  _id: string;
  name: string;
  banReason: OrganizationDetailsBanReason;
  lastLogin: string;
  organizationAdminId: string;
  organizationAdmin: CustomerUserListResponseDtoWithoutArchiveable;
  organizationUsers: CustomerUserListResponseDtoWithoutArchiveable[];
  logoUrls?: string[];
  logos?: FileDetailsResponseDto[];
  primaryColor?: string;
  secondaryColor?: string;
}

export interface ObjectId {}

export interface CustomerUserListResponseDtoWithoutArchiveable {
  _id: string;
  firstName: string;
  lastName: string;
  mail: string;
  isArchive: boolean;
  lastLogin: string;
  ownUser?: boolean;
  customerRole: CustomerUserListResponseDtoWithoutArchiveableCustomerRole;
}

export interface UpdateOrganizationRequestDto {
  name?: string;
}

export interface OrganizationResponseDto {
  _id: string;
  name: string;
  banReason: OrganizationBanReason;
  lastLogin: string;
  organizationAdminId: string;
  logo?: FileDetailsResponseDto;
  createdAt: string;
  updatedAt: string;
}

export interface FileDetailsResponseDto {
  name: string;
  path: string;
  size: number;
  mimetype: string;
}

export interface CustomerUserResponseDto {
  _id: string;
  firstName: string;
  lastName: string;
  mail: string;
  email_verified: boolean;
  email_verification_sent: boolean;
  userType: CustomerUserUserType;
  isArchive: boolean;
  lastLogin: string;
  createdAt: string;
  updatedAt: string;
  customerRole: CustomerUserCustomerRole;
  belongsToOrganizationId?: string;
}

export interface UpdateBanReasonRequestDto {
  banReason: UpdateBanReasonBanReason;
}

export interface UpdateInternalNotesRequestDto {
  internalNotes: string;
}

export interface DeleteOrganizationRequestDto {
  deleteUsers?: boolean;
  deleteAuth0Users?: boolean;
  deleteS3Assets?: boolean;
  deleteEntityData?: boolean;
  deleteBillingData?: boolean;
}

export interface DeleteOrganizationResponseDto {
  organizationId: string;
  deletedOrganization: boolean;
  deletedUsers: number;
  deletedAuth0Users: number;
  deletedS3Objects: number;
  deletedBillingContracts: number;
  canceledStripeSubscriptions: number;
  deletedStripeCustomers: number;
  deletedEntityDocuments: number;
  deletedDocumentsByCollection: Record<string, number>;
}
